import React from "react";
import { Countdown } from "../Countdown";
export function UrgencyBar() {
  return <section className="bg-black py-12 px-4 border-y-2 border-[#e10600]" data-id="element-260" data-mp="mmt8e0p8juwq">
      <div className="max-w-3xl mx-auto text-center" data-id="element-261" data-mp="mow3v095qg8u">
        <h2 className="font-condensed text-2xl sm:text-3xl text-[#e10600] tracking-widest mb-6" data-id="element-262" data-mp="rle6nukxg4ij">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <Countdown data-id="element-263" data-mp="11kbuswefxw10" />
        <p className="text-neutral-400 mt-6" data-id="element-264" data-mp="11l52bzl84pk7">
          ⚠️ Después sube <span className="text-white font-semibold" data-id="element-265" data-mp="11iitzxqie60x">$7.500 ARS</span>. No vuelve.
        </p>

        <div className="mt-8 max-w-md mx-auto" data-id="element-266" data-mp="15juexpyfu32s">
          <div className="flex items-center justify-between text-sm mb-2" data-id="element-267" data-mp="1acds4lt7qw72">
            <span className="text-[#e10600] font-semibold" data-id="element-268" data-mp="1fbgv80pmusce">🔴 Cupos al precio de lanzamiento</span>
            <span className="text-neutral-400" data-id="element-269" data-mp="1kb3a0el40gnb">Quedan pocos</span>
          </div>
          <div className="h-3 bg-neutral-800 rounded-full overflow-hidden" data-id="element-270" data-mp="1k90c78dptj81">
            <div className="h-full bg-[#e10600] rounded-full" style={{
            width: "71%"
          }} data-id="element-271" data-mp="1pa62kzjwkuee" />
          </div>
          <p className="text-xs text-neutral-500 mt-2" data-id="element-272" data-mp="1hjcujnlte9ty">
            71% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}